import { React } from "react";
import Row from "components/globals/ui/Row";
import { useFetchData } from "helpers/utils";
// import DataBadge from "components/globals/ui/ORSDataBadge"

const SingleRow = ({ id, type }) => {
	const {
		data: entry,
		loading,
		error,
	} = useFetchData(
		`${process.env.REACT_APP_SERVER_URI}/api/${type}/detail/${id}`,
		[id]
	);

	if (!id) {
		return;
	}
	
	const displayOptions = {
		layout: "row",
		yoursBadge: true,
		typeBadge: false,
		categoryBadge: true,
		userBadge: false,
		carBadge: false,
		carDetails: false,
		dateDetails: false,
		rowColumns: true,
		mobileCarousel: false,
		likes: true,
		shortRow: true,
	}

	// Loading & error states
	if (loading) return <span>Loading...</span>;
	if (error) return <span>Error: {error.message}</span>;


	return (
		<>
			<Row
				item={type === "users" ? entry : entry?.entry}
				path={type}
				displayOptions={displayOptions}
				id={type === "users" ? `entry-${entry.user_id}` : `item-${entry?.entry.internal_id}`}
			/>
		</>
	);
};

export default SingleRow;
